// Add Location
export const addLocation = (lat = undefined, lng = undefined, name = undefined, type = undefined) => {
	return {
		type: 'ADD_LOCATION',
		options: {
			lat,
			lng,
			name,
			type,
		}
	}
}

// Remove Location
export const removeLocation = (index) => {
	return {
		type: 'REMOVE_LOCATION',
		options: {
			index,
		}
	}
}

// Clear empty locations
export const clearEmptyLocations = () => {
	return {
		type: 'CLEAR_EMPTY_LOCATIONS'
	}
}

// Set Location
export const setLocation = (index = 0, lat = undefined, lng = undefined, name = undefined, type = undefined) => {
	return {
		type: 'SET_LOCATION',
		options: {
			index,
			lat,
			lng,
			name,
			type,
		}
	}
}

// Sort Locations
export const sortLocations = (newOrder) => {
	return {
		type: 'SORT_LOCATIONS',
		options: {
			newOrder,
		}
	}
}

// Clear all locations
export const clearAllLocations = () => {
	return {
		type: 'CLEAR_ALL_LOCATIONS'
	}
}



// WEBPACK FOOTER //
// ./src/actions/locations.js